import { sendFapiRequest } from './fapi';
import { errorFrom } from './fapiErrors';
import { logNetRequest } from '@utils/usefulFuncs';

// GET /feeds — every feed id the caller may view, flat and sorted, single-input and multi-input
// together (a feed is a feed; the list doesn't distinguish). Same feed_view grant as /feed/view.
export const FEEDS_PATH = '/feeds';

const FALLBACKS = {
  403: 'This account isn’t cleared for feed view. Ask a Tornado admin to add the feed_view grant, then reload this page.',
  401: 'Your session isn’t authorized for the feed API. Sign out and back in, then reload this page.',
  503: 'The feed registry is still loading on the server. Try again in a moment.',
};

export const listFeeds = async () => {
  const { status, data, error, aborted } = await sendFapiRequest('get', FEEDS_PATH);
  logNetRequest(FEEDS_PATH, status, data, error);

  if (aborted) return { status, feeds: [], aborted: true, error: null };

  if (status === 200 && data) {
    const feeds = Array.isArray(data.feeds) ? data.feeds.filter((id) => typeof id === 'string' && id) : [];
    return { status, feeds, error: null };
  }

  // A failed list is never fatal: the feed field still accepts a typed or pasted id.
  return { status, feeds: [], error: errorFrom(data, error, status, FALLBACKS) };
};
